<template>
    <listBonusComponent />
</template>

<script>
import listBonusComponent from "@/views/bonus/pages/list_bonus/components/list_bonus_component.vue/"
export default {
    name: "bonus",
    components: {
        listBonusComponent
    },
}
</script>

<style lang="css" scoped>
</style>